<template>
    <div class="body">

            <template>
              <el-select class="option" v-model="value" placeholder="全部">
                <el-option   v-for="item in options"  :key="item.value"  :label="item.label"  :value="item.value"></el-option>
              </el-select>
            </template>
            <el-input v-model="pages.condition.key" class="text" placeholder="请输入内容"></el-input>
            <el-button type="primary" class="search" @click="search">搜索</el-button>

            <!-- 表格  -->
            <el-table ref="multipleTable" :data="tableData" tooltip-effect="dark" style="width: 100%" :header-cell-style="tableHeaderColor" border  @selection-change="handleSelectionChange">
                <el-table-column type="selection"  width="55"></el-table-column>
                <el-table-column prop="id" label="序号"  width="80"></el-table-column>
                <el-table-column prop="orderId" label="订单号" ></el-table-column>
                <el-table-column prop="orderName" label="订单名称"  ></el-table-column>
                <el-table-column prop="recipients" label="收件人" width="80" ></el-table-column>
                <el-table-column prop="tel" label="手机号"  width="110" ></el-table-column>
                <el-table-column prop="addr" label="收货地址"  ></el-table-column>
                <el-table-column prop="tel" label="支付类型"  width="80" :formatter="payTypes"></el-table-column>
                <el-table-column prop="amoutPrice" label="总价" width="80"></el-table-column>
                <el-table-column prop="statusStr" label="当前状态" width="100" ></el-table-column>
                <el-table-column prop="entryDt" label="创建时间"  ></el-table-column>
                <el-table-column prop="address" label="操作">
                  <template slot-scope="scope">
                      <el-button type="primary" @click.native.prevent="updateStore(scope.row)">订单详情</el-button>
                  </template>
                </el-table-column>
            </el-table>
            <div class="page">
                 <el-pagination class="pages" background layout="prev, pager, next" :current-page="current"  @current-change="handleCurrentChange"   :total="total"></el-pagination>
            </div>
    </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
const {mapState, mapGetters, mapMutations, mapActions } = createNamespacedHelpers('product')
export default {
    data(){
        return{
        num: 1,
        dialogVisible: false,
        current:1,
        total:50,
        tableData: [],
        multipleSelection: [],
        options: [{
          value: '1',
          label: '待付款'
        }, {
          value: '2',
          label: '已付款'
        }, {
          value: '3',
          label: '已发货'
        }, {
          value: '4',
          label: '已收货'
        }, {
          value: '5',
          label: '已取消'
        },{
          value: '10',
          label: '退款中'
        },{
          value: '100',
          label: '运单号'
        }],
        value: '',
        input: '',
        pages:{
            condition:{
              key:null,
              statusCode:0
            },
            current:1,
            size:10,
            start:0,
            sorts:[
              {sortColumn:'id',sortType:'DESC'}
            ]
          }
        }
    },
    mounted(){
        this.page();
        console.log(this.pages)
    },
    computed:{
      ...mapState({
         orderId:state=>state.orderId
      })
    },
    methods: {
      ...mapMutations(['alterStoreOrderType','alterOrderId','alterOrderRefundInfo']),


      //分页查询
      page(type){
         let that = this
         this.joker.store.orderList(this.pages).then(res=>{
            console.log(res)
            that.tableData = res.content.records
            that.total = res.content.total
          }).catch(res=>{
              console.log(res)
          })
      },

      //支付类型
        payTypes(row, column){
          if(row.payType==1){
              return '支付宝'
          }else if(row.payType==2){
            return '微信'
          }else if(row.payType==3){
            return '消费券'
          }
        },
      
      //下一页
      handleCurrentChange(val) {
        this.current = val;
        this.pages.current = val
        this.page();
      },

      search(){
        this.pages.current = 1
        if(this.value==''){
            this.pages.condition.statusCode = 0
        }else{
            this.pages.condition.statusCode = this.value
        }
        this.page();
      },
      
      updateStore(row){
        this.alterOrderRefundInfo(row)
        this.alterOrderId(row.orderId)
        this.alterStoreOrderType('orderInfo')
      },

      toggleSelection(rows) {
        if (rows) {
          rows.forEach(row => {
            this.$refs.multipleTable.toggleRowSelection(row);
          });
        } else {
          this.$refs.multipleTable.clearSelection();
        }
      },
      handleSelectionChange(val) {
        this.multipleSelection = val;
      },
      // 修改table header的背景色
      tableHeaderColor({ row, column, rowIndex, columnIndex }){
            if (rowIndex === 0) {
                return 'background-color: #409EFF;color: #fff'
            }
      },
      handleClose(done) {
        this.$confirm('确认关闭？')
          .then(_ => {
            done();
          })
          .catch(_ => {});
      },
      handleChange(value) {
        console.log(value);
      }



    }    
}
</script>

<style scoped>

.option{
    margin-top: 1%;
}


.card{
    margin-left: 3%;
    margin-top: 1%;
}

.cardEl{
    padding-bottom: 5%;
}


.price{
    color: #FFFFFF;
    font-size: 30px;
    margin-top: 5%;
    line-height: 50px;
    
}
.rule{
    color: #FFFFFF;
    font-size: 15px;
}

.hr{
    width: 80%;
    text-align:center;
    margin-left: 10%;
    border:1px dashed #696969;
}

.type{
    margin-top: 1%;
    height: 40%;
    font-size: 20px;
    font-weight: 700;
}

.time{
    height: 30%;
}

.info{
    margin-top: 1%;
}

.coupon{
  clear: both;
  padding-top: 1%;
}

.couponA{
      width: 110px;
      height: 100px;
      background: linear-gradient(0.25turn, #00c6ff, #0072ff), radial-gradient(circle at 11px 4px, transparent 6px, #0072ff 6px) top left, radial-gradient(circle at 10px 56px, transparent 6px, #0072ff 6px) bottom left, linear-gradient(0.25turn, #0072ff, #0072ff);
      background-repeat: no-repeat;
      background-size: 100px 100px, 15px 100px, 15px 100px, 50px 50px;
      background-position: 0px 0px,100px -4px, 100px 26px;
      border-radius:10px;
      float: left;
}

.couponB{
    float: left;
    background-color:#FFFFFF;
    height: 100px;
    width: 300px;
    border-radius:10px;
    border:1px dashed #696969;
    position:relative;
    overflow: hidden;
}

.couponB span{
    position: absolute;
    bottom:0;
    display: block;
    font-size:12px;
    color:#fff;
    background: #36A8FF;
    width:110px;
    height: 20px;
    text-align: center;
    transform: rotate(45deg);
    top:18px;
    right:-26px;
}

.check{
    margin-top: 5%;
}

.number{
    margin-top: 99%;
}

.option{
  width: 5%;
}

.text{
 width: 30%;
}

.search{
  margin-bottom: 1%;
}

</style>


// WEBPACK FOOTER //
// src/components/Store/Order/OrderList.vue